
import Vue from 'vue'
import ModalSimple from '@/common/components/ModalSimple.vue'
import AddressList from '@/product/components/AddressList.vue'
import ZipCodeInput from '@/product/components/ZipCodeInput.vue'
import { DELIVERY_DATE_OPTIONS, ADDRESS_TYPE, ZIPCODE_LOCAL_STORAGE_KEY } from '@/product/const'
import { ENDPOINTS } from '@/checkout/constants'
import httpClient from '@/common/httpClient'
import { RecipientAddressType, ZipCodeType } from '@/types'
import { extractAddress, validateZipCode } from '@/product/utils'
import LocalStorageSerializer from '@/common/localStorageSerializer'

export default Vue.extend({
  name: 'DeliveryAddressModal',
  components: {
    ModalSimple,
    AddressList,
    ZipCodeInput
  },
  props: {
    defaultAddressType: {
      type: String,
      required: true
    },
    recipientAddressList: {
      type: Array as () => RecipientAddressType[],
      required: true
    }
  },
  data(): {
    addressType: string,
    zipCode: string
    selectedAddressId: number | undefined
    address: string
    error: string
  } {
    return {
      addressType: this.defaultAddressType,
      zipCode: LocalStorageSerializer.get(ZIPCODE_LOCAL_STORAGE_KEY) ?? '',
      selectedAddressId: undefined,
      address: '',
      error: ''
    }
  },
  computed: {
    inputOptions(): { [key: string]: string }[] {
      return this.recipientAddressList.length ? DELIVERY_DATE_OPTIONS : [DELIVERY_DATE_OPTIONS[0]]
    },
    isDeliveryOptionZipCode(): boolean {
      return this.addressType === DELIVERY_DATE_OPTIONS[0].type
    },
    previewAddress(): string {
      return this.address ? this.address : '-'
    }
  },
  watch: {
    recipientAddressList() {
      this.selectedAddressId = this.recipientAddressList[0].id
    }
  },
  created() {
    if (this.recipientAddressList.length) this.selectedAddressId = this.recipientAddressList[0].id
  },
  methods: {
    extractAddress,
    setErrorHandler(error: string) {
      this.error = error
    },
    close() {
      this.$emit('onClose')
    },
    input(zipcode: string) {
      this.zipCode = zipcode
    },
    selectAddressHandler(id: number, address: string) {
      this.selectedAddressId = id
      this.address = address
    },
    updateAddress(address: string) {
      this.address = address
    },
    async onSelect() {
      if (this.addressType === ADDRESS_TYPE.ADDRESS) {
        const selectedAddress = this.recipientAddressList.find(address => address.id === this.selectedAddressId)
        if (selectedAddress) {
          const { zip, fullAddress } = selectedAddress
          this.$emit('onSelect', zip, fullAddress, ADDRESS_TYPE.ADDRESS)
        }
      }
      else {
        const zipCodeValidate = validateZipCode(this.zipCode)
        if (zipCodeValidate) {
          this.$refs.zipcodeInput?.resetAddress()
          this.error = zipCodeValidate
          return
        }
        const res = await httpClient.get<ZipCodeType>(
        ENDPOINTS.ZIPCODE.replace(/%zipcode/, this.zipCode)
      )
        .catch(() => {
          this.$refs.zipcodeInput?.resetAddress()
          this.error = '郵便番号は不正な値です'
        })

        if (!res?.data) return

        const { data } = res
        LocalStorageSerializer.set(ZIPCODE_LOCAL_STORAGE_KEY, this.zipCode)
        this.$emit('onSelect', this.zipCode, this.extractAddress(data), ADDRESS_TYPE.ZIPCODE)
      }
    }
  }
})
